// src/ProtectedRoute.jsx
import React from 'react';
import { useRecoilValue } from 'recoil';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isLoginSelector } from './Recoil/TokenAtom';

const ProtectedRoute = () => {
    const isLogin = useRecoilValue(isLoginSelector);
    const currentLocation = useLocation();
    return isLogin ? <Outlet /> : <Navigate to="/login" replace state={{ redirectedFrom: currentLocation.pathname }} />;


};

export default ProtectedRoute;
